const noIndexPath = [
  "/list-your-property/",
];

export default noIndexPath;